module.exports = __webpack_public_path__ + "img/vi.d781054e.svg";